import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloNewsletter extends AloBase { 
    nwlDisabled:boolean
    nwlDatadd:string
    nwlDatvalid:string
    nwlDatdel:string  
    mtpId:number|null  
}

export const getDefaultAloNewsletter = (mail:string=''):AloNewsletter => {
    return {  
        ...getDefaultAloBase(),
        nwlDisabled:true,  
        nwlDatadd:'',
        nwlDatvalid:'',
        nwlDatdel:'',
        libelle:mail,
        mtpId:null
    }
}

export const cleanAloNewsletter = (newsletter:AloNewsletter) => {
    if(!newsletter) return    
    if(!newsletter.id) delete newsletter.id    
}